import React from "react";
import { apiUrl } from "../../config/apiBase";
import HintPopover from "../HintPopover";
import InfoIkona from "./AdminInfoIkona";
import AdminSortHeading from "./AdminSortHeading";
import { adminHypotekyInfoTexty } from "./adminHypotekyInfoTexty";
import { pripravHromadnyFormular } from "./adminParametreHromadne";

const CHECKBOXY = [
  ["ucet", "Účet"],
  ["poistenieUveru", "Poistenie úveru"],
  ["poistenieNehnutelnosti", "Poistenie nehnuteľnosti"],
  ["ekoCertifikat", "EKO certifikát"]
];

const MAX_POCET_VEKOVYCH_PRAVIDIEL = 3;
const MAX_POCET_VEKOVYCH_LIMITOV = 4;

const VEKOVE_PRAVIDLA_NADPISY = [
  "1. Min vek pri podaní",
  "2. Max vek pri podaní a dosplatení - 1 žiadateľ",
  "3. Max vek pri podaní a dosplatení - 2 až 4 žiadatelia"
];

const vytvorVekovePravidlo = (idx) => {
  if (idx === 0) {
    return { nazov: "Min vek pri podaní (všetci)", preKoho: "VSETCI", aplikacia: "VSETCI", limity: [{ faza: "PODANIE", koho: "VSETCI", min: "", max: "" }] };
  }
  if (idx === 1) {
    return { nazov: "Max vek pri podaní a dosplatení (1 žiadateľ)", preKoho: "JEDEN", aplikacia: "JEDINY", limity: [{ faza: "PODANIE", koho: "JEDINY", min: "", max: "" }, { faza: "DOSPLATENIE", koho: "JEDINY", min: "", max: "" }] };
  }
  return { nazov: "Max vek pri podaní a dosplatení (2+ žiadatelia)", preKoho: "VIACERI", aplikacia: "VSETCI", limity: [{ faza: "PODANIE", koho: "VSETCI", min: "", max: "" }, { faza: "DOSPLATENIE", koho: "VSETCI", min: "", max: "" }] };
};

const prazdnyBenefit = () => ({
  poznamka: "",
  zlavaSadzba: "",
  zlavaPoplatok: { typ: "ZIADNY", percento: "", eur: "" },
  podmienky: { prijemNad: { hodnota: "", dodatocnaZlavaSadzba: "" } }
});

const prazdnyFormular = () => ({
  bankaKod: "",
  bankaNazov: "",
  typHypoteky: "",
  aktivna: true,
  poznamka: "",
  suma: { min: "", max: "", poznamka: "" },
  ltv: { max: "", poznamka: "" },
  splatnostRoky: { min: "", max: "", poznamka: "" },
  vek: { pravidla: Array.from({ length: MAX_POCET_VEKOVYCH_PRAVIDIEL }, (_, idx) => ({ ...vytvorVekovePravidlo(idx), _sablona: idx })), poznamka: "" },
  prirazkaK_sadzbe: { hodnota: "", nadLTV: "", poznamka: "", podlaFixacie: [] },
  zlavaK_sadzbe: { hodnota: "", nadSuma: "", poznamka: "" },
  spracovatelskyPoplatok: { typ: "FIX", percento: { hodnota: "", min: "", max: "" }, fix: { hodnota: "" } },
  zivotneMinima: { jednotlivec: "", druhyDospely: "", dieta: "" },
  benefity: Object.fromEntries(CHECKBOXY.map(([kod]) => [kod, prazdnyBenefit()]))
});

function kopia(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function inputCislo(v) {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  return Number.isFinite(n) ? String(Math.abs(n)).replace(".", ",") : "";
}

function normalizujCislo(v) {
  const s = String(v ?? "").replace(/\s/g, "").replace(",", ".");
  return s === "" ? null : s;
}

function text(v) {
  return v === null || v === undefined ? "" : String(v);
}

function nastavV(obj, cesta, hodnota) {
  const next = kopia(obj);
  let cur = next;
  cesta.slice(0, -1).forEach((key) => {
    if (!cur[key] || typeof cur[key] !== "object") cur[key] = {};
    cur = cur[key];
  });
  cur[cesta[cesta.length - 1]] = hodnota;
  return next;
}

function formularZDat(p) {
  const f = prazdnyFormular();
  const benefity = p?.benefity || {};

  CHECKBOXY.forEach(([kod]) => {
    const b = benefity[kod] || {};
    f.benefity[kod] = {
      poznamka: text(b.poznamka),
      zlavaSadzba: inputCislo(b.zlavaSadzba),
      zlavaPoplatok: {
        typ: b.zlavaPoplatok?.typ || "ZIADNY",
        percento: inputCislo(b.zlavaPoplatok?.percento),
        eur: inputCislo(b.zlavaPoplatok?.eur)
      },
      podmienky: {
        prijemNad: {
          hodnota: inputCislo(b.podmienky?.prijemNad?.hodnota),
          dodatocnaZlavaSadzba: inputCislo(b.podmienky?.prijemNad?.dodatocnaZlavaSadzba)
        }
      }
    };
  });

  return {
    ...f,
    bankaKod: text(p?.bankaKod),
    bankaNazov: text(p?.bankaNazov),
    typHypoteky: text(p?.typHypoteky || "nadobudnutie"),
    aktivna: p?.aktivna !== false,
    poznamka: text(p?.poznamka),
    suma: { min: inputCislo(p?.suma?.min), max: inputCislo(p?.suma?.max), poznamka: text(p?.suma?.poznamka) },
    ltv: { max: inputCislo(p?.ltv?.max), poznamka: text(p?.ltv?.poznamka) },
    splatnostRoky: { min: inputCislo(p?.splatnostRoky?.min), max: inputCislo(p?.splatnostRoky?.max), poznamka: text(p?.splatnostRoky?.poznamka) },
    vek: {
      pravidla: Array.isArray(p?.vek?.pravidla)
        ? p.vek.pravidla.map((r) => ({
            _sablona: r.preKoho === "JEDEN" ? 1 : r.preKoho === "VIACERI" ? 2 : 0,
            nazov: text(r.nazov),
            preKoho: r.preKoho || "VSETCI",
            aplikacia: r.aplikacia || "VSETCI",
            limity: Array.isArray(r.limity) ? r.limity.map((l) => ({
              faza: l.faza || "PODANIE",
              koho: l.koho || "VSETCI",
              min: inputCislo(l.min),
              max: inputCislo(l.max)
            })) : []
          }))
        : [],
      poznamka: text(p?.vek?.poznamka)
    },
    prirazkaK_sadzbe: {
      hodnota: inputCislo(p?.prirazkaK_sadzbe?.hodnota),
      nadLTV: inputCislo(p?.prirazkaK_sadzbe?.nadLTV),
      poznamka: text(p?.prirazkaK_sadzbe?.poznamka),
      podlaFixacie: Array.isArray(p?.prirazkaK_sadzbe?.podlaFixacie)
        ? p.prirazkaK_sadzbe.podlaFixacie.map((x) => ({ fixaciaRoky: inputCislo(x.fixaciaRoky), hodnota: inputCislo(x.hodnota) }))
        : []
    },
    zlavaK_sadzbe: {
      hodnota: inputCislo(p?.zlavaK_sadzbe?.hodnota),
      nadSuma: inputCislo(p?.zlavaK_sadzbe?.nadSuma),
      poznamka: text(p?.zlavaK_sadzbe?.poznamka)
    },
    spracovatelskyPoplatok: {
      typ: p?.spracovatelskyPoplatok?.typ || "FIX",
      percento: {
        hodnota: inputCislo(p?.spracovatelskyPoplatok?.percento?.hodnota),
        min: inputCislo(p?.spracovatelskyPoplatok?.percento?.min),
        max: inputCislo(p?.spracovatelskyPoplatok?.percento?.max)
      },
      fix: { hodnota: inputCislo(p?.spracovatelskyPoplatok?.fix?.hodnota) }
    },
    zivotneMinima: {
      jednotlivec: inputCislo(p?.zivotneMinima?.jednotlivec),
      druhyDospely: inputCislo(p?.zivotneMinima?.druhyDospely),
      dieta: inputCislo(p?.zivotneMinima?.dieta)
    },
    benefity: f.benefity
  };
}

function dataNaUlozenie(f) {
  const out = kopia(f);
  [
    ["suma", "min"], ["suma", "max"], ["ltv", "max"], ["splatnostRoky", "min"], ["splatnostRoky", "max"],
    ["prirazkaK_sadzbe", "hodnota"], ["prirazkaK_sadzbe", "nadLTV"], ["zlavaK_sadzbe", "hodnota"], ["zlavaK_sadzbe", "nadSuma"],
    ["spracovatelskyPoplatok", "percento", "hodnota"], ["spracovatelskyPoplatok", "percento", "min"], ["spracovatelskyPoplatok", "percento", "max"], ["spracovatelskyPoplatok", "fix", "hodnota"],
    ["zivotneMinima", "jednotlivec"], ["zivotneMinima", "druhyDospely"], ["zivotneMinima", "dieta"]
  ].forEach((cesta) => {
    let cur = out;
    cesta.slice(0, -1).forEach((key) => { cur = cur[key]; });
    cur[cesta[cesta.length - 1]] = normalizujCislo(cur[cesta[cesta.length - 1]]);
  });

  out.prirazkaK_sadzbe.podlaFixacie = (out.prirazkaK_sadzbe.podlaFixacie || [])
    .map((x) => ({ fixaciaRoky: normalizujCislo(x.fixaciaRoky), hodnota: normalizujCislo(x.hodnota) }))
    .filter((x) => x.fixaciaRoky !== null || x.hodnota !== null);

  out.vek.pravidla = (out.vek.pravidla || []).map((r) => ({
    nazov: r.nazov,
    preKoho: r.preKoho,
    aplikacia: r.aplikacia,
    limity: (r.limity || []).map((l) => ({ ...l, min: normalizujCislo(l.min), max: normalizujCislo(l.max) })).filter((l) => l.min !== null || l.max !== null)
  })).filter((r) => r.limity.length);

  CHECKBOXY.forEach(([kod]) => {
    const b = out.benefity[kod];
    b.zlavaSadzba = normalizujCislo(b.zlavaSadzba);
    b.zlavaPoplatok.percento = normalizujCislo(b.zlavaPoplatok.percento);
    b.zlavaPoplatok.eur = normalizujCislo(b.zlavaPoplatok.eur);
    b.podmienky.prijemNad.hodnota = normalizujCislo(b.podmienky.prijemNad.hodnota);
    b.podmienky.prijemNad.dodatocnaZlavaSadzba = normalizujCislo(b.podmienky.prijemNad.dodatocnaZlavaSadzba);
  });

  return out;
}

function Hodnota({ label, value, onChange, children, className = "", disabled = false, maxLength, info, rozdielne = false }) {
  return (
    <div className={`pdf-modal__field ${className}`.trim()}>
      <span className="pdf-modal__label">{label} {info && <InfoIkona obsah={info} nazov={label} />}</span>
      {children || <input placeholder={rozdielne ? "Rôzne hodnoty" : undefined} aria-label={label} className="pdf-modal__input" value={value} disabled={disabled} maxLength={maxLength} onChange={(e) => onChange(e.target.value)} />}
    </div>
  );
}

function Vyber({ label, value, onChange, children, className = "", disabled = false, info, rozdielne = false }) {
  return (
    <Hodnota label={label} className={className} info={info}>
      <select aria-label={label} className="pdf-modal__input" value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
        {rozdielne && <option value="" disabled>Rôzne hodnoty</option>}
        {children}
      </select>
    </Hodnota>
  );
}

export default function AdminHypotekyParametre() {
  const [meta, setMeta] = React.useState({ banky: [], typyHypoteky: [], parametre: {} });
  const [parametre, setParametre] = React.useState([]);
  const [filterBanka, setFilterBanka] = React.useState("");
  const [filterTyp, setFilterTyp] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editParam, setEditParam] = React.useState(null);
  const [formular, setFormular] = React.useState(prazdnyFormular());
  const [modalError, setModalError] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [deleteParam, setDeleteParam] = React.useState(null);
  const [deleteBanka, setDeleteBanka] = React.useState(null);
  const [bulkOpen, setBulkOpen] = React.useState(false);
  const [bulkZmeny, setBulkZmeny] = React.useState({});
  const [bulkRozdielne, setBulkRozdielne] = React.useState([]);
  const [bulkNacitava, setBulkNacitava] = React.useState(false);
  const infoTexty = adminHypotekyInfoTexty[bulkOpen ? "parametreHromadne" : editParam ? "parametreUpravit" : "parametrePridat"];
  const [zoradenie, setZoradenie] = React.useState({ stlpec: "", smer: "asc" });
  const prepniZoradenie = (stlpec) => setZoradenie((prev) => ({ stlpec, smer: prev.stlpec === stlpec && prev.smer === "asc" ? "desc" : "asc" }));
  const zobrazeneParametre = React.useMemo(() => {
    const smer = zoradenie.smer === "desc" ? -1 : 1;
    const indexy = new Map(parametre.map((p, index) => [String(p.id), index]));
    const hodnota = (p) => {
      if (zoradenie.stlpec === "banka") return p.bankaKod || "";
      if (zoradenie.stlpec === "stav") return p.aktivna ? "Aktívne" : "Vypnuté";
      return p.updatedAt ? new Date(p.updatedAt).getTime() || 0 : 0;
    };
    return [...parametre].sort((a, b) => {
      const stavovyRozdiel = (a.aktivna ? 0 : 1) - (b.aktivna ? 0 : 1);
      if (stavovyRozdiel !== 0) return stavovyRozdiel;
      if (!zoradenie.stlpec) return (indexy.get(String(a.id)) || 0) - (indexy.get(String(b.id)) || 0);

      const x = hodnota(a);
      const y = hodnota(b);
      const porovnanie = typeof x === "number" ? x - y : x.localeCompare(y, "sk", { sensitivity: "base" });
      return porovnanie * smer || String(a.id).localeCompare(String(b.id));
    });
  }, [parametre, zoradenie]);

  const nacitajMeta = React.useCallback(async () => {
    const r = await fetch(apiUrl("/api/admin/hypoteky/meta"), { credentials: "include" });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data?.message || "Meta dáta sa nepodarilo načítať.");
    setMeta(data || { banky: [], typyHypoteky: [], parametre: {} });
  }, []);

  const nacitajParametre = React.useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const q = new URLSearchParams();
      if (filterBanka) q.set("bankaKod", filterBanka);
      if (filterTyp) q.set("typHypoteky", filterTyp);
      const r = await fetch(apiUrl(`/api/admin/hypoteky/parametre?${q.toString()}`), { credentials: "include" });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data?.message || "Parametre sa nepodarilo načítať.");
      setParametre(Array.isArray(data.parametre) ? data.parametre : []);
    } catch (e) {
      setError(e.message || "Parametre sa nepodarilo načítať.");
    } finally {
      setLoading(false);
    }
  }, [filterBanka, filterTyp]);

  React.useEffect(() => { nacitajMeta().catch((e) => setError(e.message)); }, [nacitajMeta]);
  React.useEffect(() => { nacitajParametre(); }, [nacitajParametre]);

  const typyHypoteky = React.useMemo(() => {
    const set = new Set([...(meta.typyHypoteky || []), ...(meta.parametre?.typyHypoteky || []), ...parametre.map((p) => p.typHypoteky)]);
    return Array.from(set).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b), "sk"));
  }, [meta, parametre]);

  const banky = React.useMemo(() => {
    const map = new Map();
    (meta.banky || []).forEach((b) => b.bankaKod && map.set(b.bankaKod, b));
    parametre.forEach((p) => p.bankaKod && !map.has(p.bankaKod) && map.set(p.bankaKod, { bankaKod: p.bankaKod, bankaNazov: p.bankaNazov || p.bankaKod }));
    return Array.from(map.values()).sort((a, b) => String(a.bankaKod).localeCompare(String(b.bankaKod), "sk"));
  }, [meta, parametre]);

  const vybranaBanka = React.useMemo(
    () => banky.find((b) => b.bankaKod === filterBanka),
    [banky, filterBanka]
  );

  const nastav = (cesta, hodnota) => {
    if (bulkOpen) setBulkZmeny((prev) => ({ ...prev, [cesta.join(".")]: hodnota }));
    setFormular((prev) => nastavV(prev, cesta, hodnota));
    setModalError("");
  };

  const otvorPridanie = (bankaKod = "") => {
    const banka = banky.find((b) => b.bankaKod === bankaKod);
    setEditParam(null);
    setBulkOpen(false);
    setFormular({ ...prazdnyFormular(), bankaKod, bankaNazov: banka?.bankaNazov || bankaKod, typHypoteky: filterTyp || "" });
    setModalOpen(true);
  };

  const otvorUpravu = (p) => {
    setEditParam(p);
    setBulkOpen(false);
    setFormular(formularZDat(p));
    setModalOpen(true);
  };

  const uloz = async () => {
    if (saving) return;
    setSaving(true);
    setModalError("");
    try {
      const r = await fetch(apiUrl(editParam ? `/api/admin/hypoteky/parametre/${editParam.id}` : "/api/admin/hypoteky/parametre"), {
        method: editParam ? "PATCH" : "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(dataNaUlozenie(formular))
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data?.message || "Parametre sa nepodarilo uložiť.");
      setModalOpen(false);
      setMessage(data?.message || "Parametre boli uložené.");
      await nacitajMeta();
      await nacitajParametre();
    } catch (e) {
      setModalError(e.message || "Parametre sa nepodarilo uložiť.");
    } finally {
      setSaving(false);
    }
  };

  const ulozHromadne = async () => {
    if (saving) return;
    if (!Object.keys(bulkZmeny).length) {
      setModalError("Upravte aspoň jedno pole.");
      return;
    }
    setSaving(true);
    setModalError("");
    try {
      const r = await fetch(apiUrl(`/api/admin/hypoteky/parametre/banka/${encodeURIComponent(formular.bankaKod)}/hromadne`), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ zmeny: bulkZmeny })
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data?.message || "Hromadnú úpravu sa nepodarilo uložiť.");
      setModalOpen(false);
      setMessage(data.message || "Hromadná úprava bola uložená.");
      await nacitajParametre();
    } catch (e) {
      setModalError(e.message || "Hromadnú úpravu sa nepodarilo uložiť.");
    } finally {
      setSaving(false);
    }
  };
  const vymazTyp = async () => {
    const r = await fetch(apiUrl(`/api/admin/hypoteky/parametre/${deleteParam.id}`), { method: "DELETE", credentials: "include" });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) return setError(data?.message || "Parametre sa nepodarilo vymazať.");
    setDeleteParam(null);
    setMessage(data?.message || "Parametre boli vymazané.");
    await nacitajMeta();
    await nacitajParametre();
  };

  const vymazBanku = async () => {
    const r = await fetch(apiUrl(`/api/admin/hypoteky/parametre/banka/${encodeURIComponent(deleteBanka.bankaKod)}`), { method: "DELETE", credentials: "include" });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) return setError(data?.message || "Banku sa nepodarilo vymazať.");
    setDeleteBanka(null);
    setMessage(data?.message || "Banka bola vymazaná.");
    await nacitajMeta();
    await nacitajParametre();
  };

  const otvorHromadne = async () => {
    if (!filterBanka || bulkNacitava) return;
    setBulkNacitava(true);
    setError("");
    try {
      const q = new URLSearchParams({ bankaKod: filterBanka });
      const r = await fetch(apiUrl(`/api/admin/hypoteky/parametre?${q}`), { credentials: "include" });
      const data = await r.json();
      if (!r.ok || !data.parametre?.length) throw new Error(data.message || "Banka nemá žiadne karty parametrov.");
      const karty = data.parametre.map(formularZDat);
      const { formular: spolocny, rozdielne } = pripravHromadnyFormular(karty, prazdnyFormular());
      setEditParam(null);
      setBulkOpen(true);
      setBulkZmeny({});
      setBulkRozdielne(rozdielne);
      setFormular({ ...spolocny, bankaKod: filterBanka, bankaNazov: karty[0].bankaNazov });
      setModalError("");
      setModalOpen(true);
    } catch (e) {
      setError(e.message || "Parametre banky sa nepodarilo načítať.");
    } finally {
      setBulkNacitava(false);
    }
  };
  const pridajVekPravidlo = () => {
    if (formular.vek.pravidla.length >= MAX_POCET_VEKOVYCH_PRAVIDIEL) return;
    const idx = Array.from({ length: MAX_POCET_VEKOVYCH_PRAVIDIEL }, (_, i) => i)
      .find((i) => !formular.vek.pravidla.some((r) => r._sablona === i));
    if (idx === undefined) return;
    nastav(["vek", "pravidla"], [...formular.vek.pravidla, { ...vytvorVekovePravidlo(idx), _sablona: idx }]);
  };

  const pridajLimitVekovePravidlo = (idx) => {
    nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => (
      i === idx && x.limity.length < MAX_POCET_VEKOVYCH_LIMITOV ? { ...x, limity: [...x.limity, { faza: "PODANIE", koho: "VSETCI", min: "", max: "" }] } : x
    )));
  };

  const pridajPrirazkuFix = () => {
    nastav(["prirazkaK_sadzbe", "podlaFixacie"], [...formular.prirazkaK_sadzbe.podlaFixacie, { fixaciaRoky: "", hodnota: "" }]);
  };

  return (
    <div className="card-section admin-users-card admin-parametre-card">
      <div className="admin-users-header">
        <div>
          <h2>Parametre bánk</h2>
          <div className="form_hint">Karty podľa banky a typu hypotéky. Zmeny sa premietajú do porovnávača a prehľadu zliav/prirážok.</div>
        </div>
        <div className="admin-users-header-actions">
          <button type="button" className="action-btn" onClick={nacitajParametre}>Obnoviť</button>
          <button type="button" className="action-btn" onClick={() => otvorPridanie(filterBanka)}>+ Pridať typ/banku</button>
          <button type="button" className="action-btn" disabled={!filterBanka || bulkNacitava} onClick={otvorHromadne}>Hromadná úprava banky</button>
          <button type="button" className="action-btn admin-danger-btn" disabled={!filterBanka} onClick={() => setDeleteBanka({ bankaKod: filterBanka, bankaNazov: vybranaBanka?.bankaNazov || filterBanka })}>Vymazať banku</button>
        </div>
      </div>

      <div className="admin-hypoteky-toolbar admin-parametre-toolbar">
        <select className="form_select admin-hypoteky-filter" value={filterBanka} onChange={(e) => setFilterBanka(e.target.value)}>
          <option value="">Všetky banky</option>
          {banky.map((b) => <option key={b.bankaKod} value={b.bankaKod}>{b.bankaKod}</option>)}
        </select>
        <select className="form_select admin-hypoteky-filter" value={filterTyp} onChange={(e) => setFilterTyp(e.target.value)}>
          <option value="">Všetky typy</option>
          {typyHypoteky.map((typ) => <option key={typ} value={typ}>{typ}</option>)}
        </select>
      </div>

      {error && <div className="admin-users-message admin-users-message--error">{error}</div>}
      {message && <div className="admin-users-message">{message}</div>}

      <div className="admin-users-table-wrap">
        <table className="admin-users-table admin-parametre-table">
          <thead>
            <tr>
              <AdminSortHeading stlpec="banka" zoradenie={zoradenie} onSort={prepniZoradenie}>Banka</AdminSortHeading>
              <th>Typ hypotéky</th>
              <th>Poznámka</th>
              <AdminSortHeading stlpec="stav" zoradenie={zoradenie} onSort={prepniZoradenie}>Stav</AdminSortHeading>
              <AdminSortHeading stlpec="uprava" zoradenie={zoradenie} onSort={prepniZoradenie}>Posledná úprava</AdminSortHeading>
              <th>Akcie</th>
            </tr>
          </thead>
          <tbody>
            {!loading && zobrazeneParametre.map((p) => (
              <tr key={p.id}>
                <td data-label="Banka">{p.bankaKod}</td>
                <td data-label="Typ hypotéky">{p.typHypoteky}</td>
                <td data-label="Poznámka">
                  {p.poznamka ? <HintPopover obsah={p.poznamka} ariaLabel="Zobraziť celú poznámku" wrapperClassName="admin-parametre-note" triggerClassName="admin-parametre-note-trigger"><span>{p.poznamka}</span></HintPopover> : "-"}
                </td>
                <td data-label="Stav">
                  <span className={`admin-status ${p.aktivna ? "admin-status--active" : "admin-status--onboarding"}`}>{p.aktivna ? "Aktívne" : "Vypnuté"}</span>
                </td>
                <td data-label="Posledná úprava">{p.updatedAt ? new Date(p.updatedAt).toLocaleDateString("sk-SK") : "-"}</td>
                <td data-label="Akcie">
                  <div className="admin-users-row-actions">
                    <button type="button" className="action-btn" onClick={() => otvorUpravu(p)}>Upraviť</button>
                    <button type="button" className="action-btn admin-danger-btn" onClick={() => setDeleteParam(p)}>Vymazať typ</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {loading && <div className="admin-users-empty">Načítavam parametre...</div>}
      {!loading && !parametre.length && <div className="admin-users-empty">Nenašli sa žiadne parametre.</div>}

      {modalOpen && (
        <div className="pdf-modal-overlay" onClick={() => !saving && setModalOpen(false)}>
          <div className="pdf-modal admin-parametre-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal__header admin-kampane-modal-header">
              <h2 className="pdf-modal__title">{bulkOpen ? "Hromadná úprava banky" : editParam ? "Upraviť parametre" : "Pridať parametre"}</h2>
              <div className="admin-parametre-header-actions">
                {bulkOpen && <InfoIkona obsah={infoTexty.hromadne} nazov="Hromadná úprava banky" />}
                {editParam && !bulkOpen && (
                  <label className="admin-access-option admin-kampane-header-toggle">
                    <input type="checkbox" checked={formular.aktivna === false} onChange={(e) => nastav(["aktivna"], !e.target.checked)} /> Manuálne vypnúť kartu
                  </label>
                )}
              </div>
            </div>
            <div className="pdf-modal__body">
              <div className="admin-kampane-section">
                <h3><span>Identifikácia</span> <InfoIkona obsah={infoTexty.identifikacia} nazov="Identifikácia" /></h3>
                <div className="admin-parametre-row">
                  <Hodnota label="Skratka banky" value={formular.bankaKod} disabled={!!editParam || bulkOpen} rozdielne={bulkOpen && bulkRozdielne.includes(["bankaKod"].join("."))} onChange={(v) => nastav(["bankaKod"], v)} />
                  <Hodnota label="Názov banky" value={formular.bankaNazov} disabled={!!editParam || bulkOpen} rozdielne={bulkOpen && bulkRozdielne.includes(["bankaNazov"].join("."))} onChange={(v) => nastav(["bankaNazov"], v)} />
                  {bulkOpen ? <Hodnota label="Typ hypotéky" value="Všetky" disabled /> : !editParam ? <Hodnota label="Typ hypotéky" value={formular.typHypoteky} onChange={(v) => nastav(["typHypoteky"], v)} /> : <Vyber label="Typ hypotéky" value={formular.typHypoteky} onChange={(v) => nastav(["typHypoteky"], v)}>
                    {typyHypoteky.map((typ) => <option key={typ} value={typ}>{typ}</option>)}
                  </Vyber>}
                </div>
                {!bulkOpen && <Hodnota label="Poznámka ku karte (max 200 znakov)" className="admin-parametre-wide-inline" value={formular.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["poznamka"].join("."))} onChange={(v) => nastav(["poznamka"], v)} />}
              </div>

              {!bulkOpen && (
                <>
                  <div className="admin-kampane-section">
                    <h3><span>Limity úveru</span> <InfoIkona obsah={infoTexty.limity} nazov="Limity úveru" /></h3>
                    <h4><span>Výška úveru</span> <InfoIkona obsah={infoTexty.suma} nazov="Výška úveru" /></h4>
                    <div className="admin-parametre-row">
                      <Hodnota label="Min (€)" value={formular.suma.min} rozdielne={bulkOpen && bulkRozdielne.includes(["suma", "min"].join("."))} onChange={(v) => nastav(["suma", "min"], v)} />
                      <Hodnota label="Max (€)" value={formular.suma.max} rozdielne={bulkOpen && bulkRozdielne.includes(["suma", "max"].join("."))} onChange={(v) => nastav(["suma", "max"], v)} />
                      <Hodnota label="Poznámka (max 200 znakov)" className="admin-parametre-wide-inline" value={formular.suma.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["suma", "poznamka"].join("."))} onChange={(v) => nastav(["suma", "poznamka"], v)} />
                    </div>
                    <h4><span>LTV</span> <InfoIkona obsah={infoTexty.ltv} nazov="LTV" /></h4>
                    <div className="admin-parametre-row">
                      <Hodnota label="Max (%)" value={formular.ltv.max} rozdielne={bulkOpen && bulkRozdielne.includes(["ltv", "max"].join("."))} onChange={(v) => nastav(["ltv", "max"], v)} />
                      <Hodnota label="Poznámka (max 200 znakov)" className="admin-parametre-wide-inline" value={formular.ltv.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["ltv", "poznamka"].join("."))} onChange={(v) => nastav(["ltv", "poznamka"], v)} />
                    </div>
                    <h4><span>Splatnosť</span> <InfoIkona obsah={infoTexty.splatnost} nazov="Splatnosť" /></h4>
                    <div className="admin-parametre-row">
                      <Hodnota label="Min (r)" value={formular.splatnostRoky.min} rozdielne={bulkOpen && bulkRozdielne.includes(["splatnostRoky", "min"].join("."))} onChange={(v) => nastav(["splatnostRoky", "min"], v)} />
                      <Hodnota label="Max (r)" value={formular.splatnostRoky.max} rozdielne={bulkOpen && bulkRozdielne.includes(["splatnostRoky", "max"].join("."))} onChange={(v) => nastav(["splatnostRoky", "max"], v)} />
                      <Hodnota label="Poznámka (max 200 znakov)" className="admin-parametre-wide-inline" value={formular.splatnostRoky.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["splatnostRoky", "poznamka"].join("."))} onChange={(v) => nastav(["splatnostRoky", "poznamka"], v)} />
                    </div>
                  </div>

                  <div className="admin-kampane-section">
                    <h3><span>Vekové pravidlá</span> <InfoIkona obsah={infoTexty.vek} nazov="Vekové pravidlá" /></h3>
                    {formular.vek.pravidla.map((r, idx) => (
                      <div className="admin-parametre-rule" key={`vek-${idx}`}>
                        <h4>{r.nazov || VEKOVE_PRAVIDLA_NADPISY[r._sablona] || `Vekové pravidlo ${idx + 1}`}</h4>
                        <div className="admin-parametre-row">
                          <Hodnota label="Názov" value={r.nazov} maxLength={120} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, nazov: v } : x))} />
                          <Vyber label="Pre koho" info={infoTexty.preKoho} value={r.preKoho} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, preKoho: v } : x))}>
                            <option value="VSETCI">Všetci</option><option value="JEDEN">1 žiadateľ</option><option value="VIACERI">2 až 4 žiadatelia</option>
                          </Vyber>
                          <Vyber label="Aplikácia" info={infoTexty.aplikacia} value={r.aplikacia} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, aplikacia: v } : x))}>
                            <option value="VSETCI">Každý</option><option value="JEDINY">Jediný</option><option value="NAJMLADSI_NAJSTARSI">Najmladší/najstarší</option><option value="ASPON_JEDEN">Aspoň jeden</option>
                          </Vyber>
                        </div>
                        {r.limity.map((l, lidx) => (
                          <div className="admin-parametre-row" key={`limit-${idx}-${lidx}`}>
                            <Vyber label="Fáza" info={infoTexty.faza} value={l.faza} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, limity: x.limity.map((y, j) => j === lidx ? { ...y, faza: v } : y) } : x))}>
                              <option value="PODANIE">Pri podaní</option><option value="DOSPLATENIE">Pri dosplatení</option>
                            </Vyber>
                            <Vyber label="Kto" info={infoTexty.koho} value={l.koho} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, limity: x.limity.map((y, j) => j === lidx ? { ...y, koho: v } : y) } : x))}>
                              <option value="VSETCI">Všetci</option><option value="JEDINY">Jediný</option><option value="NAJMLADSI">Najmladší</option><option value="NAJSTARSI">Najstarší</option>
                            </Vyber>
                            <Hodnota label="Min (r)" value={l.min} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, limity: x.limity.map((y, j) => j === lidx ? { ...y, min: v } : y) } : x))} />
                            <Hodnota label="Max (r)" value={l.max} onChange={(v) => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, limity: x.limity.map((y, j) => j === lidx ? { ...y, max: v } : y) } : x))} />
                            <button type="button" className="action-btn admin-danger-btn" aria-label="Odobrať limit" onClick={() => nastav(["vek", "pravidla"], formular.vek.pravidla.map((x, i) => i === idx ? { ...x, limity: x.limity.filter((_, j) => j !== lidx) } : x))}>−</button>
                          </div>
                        ))}
                        <div className="admin-parametre-rule-actions">
                          <button type="button" className="action-btn" disabled={r.limity.length >= MAX_POCET_VEKOVYCH_LIMITOV} onClick={() => pridajLimitVekovePravidlo(idx)}>+ Limit</button>
                          <button type="button" className="action-btn admin-danger-btn" onClick={() => nastav(["vek", "pravidla"], formular.vek.pravidla.filter((_, i) => i !== idx))}>Odobrať pravidlo</button>
                        </div>
                      </div>
                    ))}
                    {formular.vek.pravidla.length < MAX_POCET_VEKOVYCH_PRAVIDIEL && (
                      <button type="button" className="action-btn" onClick={pridajVekPravidlo}>+ Vekové pravidlo</button>
                    )}
                    <Hodnota label="Poznámka k veku (max 200 znakov)" value={formular.vek.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["vek", "poznamka"].join("."))} onChange={(v) => nastav(["vek", "poznamka"], v)} />
                  </div>

                  <div className="admin-kampane-section">
                    <h3><span>Sadzbové úpravy</span> <InfoIkona obsah={infoTexty.sadzboveUpravy} nazov="Sadzbové úpravy" /></h3>
                    <h4><span>Prirážka k sadzbe</span> <InfoIkona obsah={infoTexty.prirazka} nazov="Prirážka k sadzbe" /></h4>
                    <div className="admin-parametre-row">
                      <Hodnota label="Prirážka (%)" value={formular.prirazkaK_sadzbe.hodnota} rozdielne={bulkOpen && bulkRozdielne.includes(["prirazkaK_sadzbe", "hodnota"].join("."))} onChange={(v) => nastav(["prirazkaK_sadzbe", "hodnota"], v)} />
                      <Hodnota label="Nad LTV (%)" value={formular.prirazkaK_sadzbe.nadLTV} rozdielne={bulkOpen && bulkRozdielne.includes(["prirazkaK_sadzbe", "nadLTV"].join("."))} onChange={(v) => nastav(["prirazkaK_sadzbe", "nadLTV"], v)} />
                      <Hodnota label="Poznámka (max 200 znakov)" className="admin-parametre-wide-inline" value={formular.prirazkaK_sadzbe.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["prirazkaK_sadzbe", "poznamka"].join("."))} onChange={(v) => nastav(["prirazkaK_sadzbe", "poznamka"], v)} />
                    </div>
                    {formular.prirazkaK_sadzbe.podlaFixacie.map((x, idx) => (
                      <div className="admin-parametre-row" key={`fix-${idx}`}>
                        <Hodnota label="Fixácia (r)" value={x.fixaciaRoky} onChange={(v) => nastav(["prirazkaK_sadzbe", "podlaFixacie"], formular.prirazkaK_sadzbe.podlaFixacie.map((y, i) => i === idx ? { ...y, fixaciaRoky: v } : y))} />
                        <Hodnota label="Prirážka (%)" value={x.hodnota} onChange={(v) => nastav(["prirazkaK_sadzbe", "podlaFixacie"], formular.prirazkaK_sadzbe.podlaFixacie.map((y, i) => i === idx ? { ...y, hodnota: v } : y))} />
                        <button type="button" className="action-btn admin-danger-btn" onClick={() => nastav(["prirazkaK_sadzbe", "podlaFixacie"], formular.prirazkaK_sadzbe.podlaFixacie.filter((_, i) => i !== idx))}>Odobrať</button>
                      </div>
                    ))}
                    <button type="button" className="action-btn" onClick={pridajPrirazkuFix}>+ Prirážka podľa fixácie</button>
                    <h4><span>Zľava k sadzbe</span> <InfoIkona obsah={infoTexty.zlava} nazov="Zľava k sadzbe" /></h4>
                    <div className="admin-parametre-row">
                      <Hodnota label="Zľava (%)" value={formular.zlavaK_sadzbe.hodnota} rozdielne={bulkOpen && bulkRozdielne.includes(["zlavaK_sadzbe", "hodnota"].join("."))} onChange={(v) => nastav(["zlavaK_sadzbe", "hodnota"], v)} />
                      <Hodnota label="Nad výšku (€)" value={formular.zlavaK_sadzbe.nadSuma} rozdielne={bulkOpen && bulkRozdielne.includes(["zlavaK_sadzbe", "nadSuma"].join("."))} onChange={(v) => nastav(["zlavaK_sadzbe", "nadSuma"], v)} />
                      <Hodnota label="Poznámka (max 200 znakov)" className="admin-parametre-wide-inline" value={formular.zlavaK_sadzbe.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["zlavaK_sadzbe", "poznamka"].join("."))} onChange={(v) => nastav(["zlavaK_sadzbe", "poznamka"], v)} />
                    </div>
                  </div>
                </>
              )}

              <div className="admin-kampane-section">
                <h3><span>Spracovateľský poplatok</span> <InfoIkona obsah={infoTexty.poplatok} nazov="Spracovateľský poplatok" /></h3>
                <div className="admin-parametre-row">
                  <Vyber label="Typ" value={formular.spracovatelskyPoplatok.typ} rozdielne={bulkOpen && bulkRozdielne.includes(["spracovatelskyPoplatok", "typ"].join("."))} onChange={(v) => nastav(["spracovatelskyPoplatok", "typ"], v)}>
                    <option value="FIX">Fixný poplatok</option><option value="PERCENTO">Percento zo sumy</option>
                  </Vyber>
                  {formular.spracovatelskyPoplatok.typ === "FIX" ? (
                    <Hodnota label="Hodnota (€)" value={formular.spracovatelskyPoplatok.fix.hodnota} rozdielne={bulkOpen && bulkRozdielne.includes(["spracovatelskyPoplatok", "fix", "hodnota"].join("."))} onChange={(v) => nastav(["spracovatelskyPoplatok", "fix", "hodnota"], v)} />
                  ) : (
                    <>
                      <Hodnota label="Percento (%)" value={formular.spracovatelskyPoplatok.percento.hodnota} rozdielne={bulkOpen && bulkRozdielne.includes(["spracovatelskyPoplatok", "percento", "hodnota"].join("."))} onChange={(v) => nastav(["spracovatelskyPoplatok", "percento", "hodnota"], v)} />
                      <Hodnota label="Min (€)" value={formular.spracovatelskyPoplatok.percento.min} rozdielne={bulkOpen && bulkRozdielne.includes(["spracovatelskyPoplatok", "percento", "min"].join("."))} onChange={(v) => nastav(["spracovatelskyPoplatok", "percento", "min"], v)} />
                      <Hodnota label="Max (€)" value={formular.spracovatelskyPoplatok.percento.max} rozdielne={bulkOpen && bulkRozdielne.includes(["spracovatelskyPoplatok", "percento", "max"].join("."))} onChange={(v) => nastav(["spracovatelskyPoplatok", "percento", "max"], v)} />
                    </>
                  )}
                </div>
              </div>

              <div className="admin-kampane-section">
                <h3><span>Životné minimá</span> <InfoIkona obsah={infoTexty.zivotneMinima} nazov="Životné minimá" /></h3>
                <div className="admin-parametre-row">
                  <Hodnota label="Jeden dospelý (€)" value={formular.zivotneMinima.jednotlivec} rozdielne={bulkOpen && bulkRozdielne.includes(["zivotneMinima", "jednotlivec"].join("."))} onChange={(v) => nastav(["zivotneMinima", "jednotlivec"], v)} />
                  <Hodnota label="Ďalší dospelý (€)" value={formular.zivotneMinima.druhyDospely} rozdielne={bulkOpen && bulkRozdielne.includes(["zivotneMinima", "druhyDospely"].join("."))} onChange={(v) => nastav(["zivotneMinima", "druhyDospely"], v)} />
                  <Hodnota label="Dieťa (€)" value={formular.zivotneMinima.dieta} rozdielne={bulkOpen && bulkRozdielne.includes(["zivotneMinima", "dieta"].join("."))} onChange={(v) => nastav(["zivotneMinima", "dieta"], v)} />
                </div>
              </div>

              <div className="admin-kampane-section">
                <h3><span>Benefity / checkboxy</span> <InfoIkona obsah={infoTexty.benefity} nazov="Benefity / checkboxy" /></h3>
                {CHECKBOXY.map(([kod, nazov]) => {
                  const b = formular.benefity[kod];
                  return (
                    <div className="admin-parametre-benefit" key={kod}>
                      <h4>{nazov} <InfoIkona obsah={infoTexty[kod]} nazov={nazov} /></h4>
                      <div className="admin-parametre-row">
                        <Hodnota label="Zľava sadzby (%)" value={b.zlavaSadzba} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "zlavaSadzba"].join("."))} onChange={(v) => nastav(["benefity", kod, "zlavaSadzba"], v)} />
                        <Vyber label="Zľava z poplatku" value={b.zlavaPoplatok.typ} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "zlavaPoplatok", "typ"].join("."))} onChange={(v) => nastav(["benefity", kod, "zlavaPoplatok", "typ"], v)}>
                          <option value="ZIADNY">Žiadna</option><option value="PERCENTO">Percento</option><option value="FIX">Eurá</option>
                        </Vyber>
                        {b.zlavaPoplatok.typ === "PERCENTO" && <Hodnota label="Poplatok (%)" value={b.zlavaPoplatok.percento} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "zlavaPoplatok", "percento"].join("."))} onChange={(v) => nastav(["benefity", kod, "zlavaPoplatok", "percento"], v)} />}
                        {b.zlavaPoplatok.typ === "FIX" && <Hodnota label="Poplatok (€)" value={b.zlavaPoplatok.eur} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "zlavaPoplatok", "eur"].join("."))} onChange={(v) => nastav(["benefity", kod, "zlavaPoplatok", "eur"], v)} />}
                        <Hodnota label="Poznámka (max 200 znakov)" className="admin-parametre-wide-inline" value={b.poznamka} maxLength={200} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "poznamka"].join("."))} onChange={(v) => nastav(["benefity", kod, "poznamka"], v)} />
                      </div>
                      {kod === "ucet" && (
                        <div className="admin-parametre-row">
                          <Hodnota label="Príjem nad (€)" value={b.podmienky.prijemNad.hodnota} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "podmienky", "prijemNad", "hodnota"].join("."))} onChange={(v) => nastav(["benefity", kod, "podmienky", "prijemNad", "hodnota"], v)} />
                          <Hodnota label="Dodatočná zľava (%)" value={b.podmienky.prijemNad.dodatocnaZlavaSadzba} rozdielne={bulkOpen && bulkRozdielne.includes(["benefity", kod, "podmienky", "prijemNad", "dodatocnaZlavaSadzba"].join("."))} onChange={(v) => nastav(["benefity", kod, "podmienky", "prijemNad", "dodatocnaZlavaSadzba"], v)} />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {modalError && <div className="admin-modal-error">{modalError}</div>}
            </div>
            <div className="pdf-modal__footer">
              <button type="button" className="action-btn" disabled={saving} onClick={() => { setModalOpen(false); setBulkOpen(false); }}>Zrušiť</button>
              <button type="button" className="action-btn" disabled={saving} onClick={bulkOpen ? ulozHromadne : uloz}>{saving ? "Ukladám..." : "Uložiť"}</button>
            </div>
          </div>
        </div>
      )}

      {deleteParam && (
        <div className="pdf-modal-overlay" onClick={() => setDeleteParam(null)}>
          <div className="pdf-modal admin-delete-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal__header"><h2 className="pdf-modal__title">Vymazať typ hypotéky</h2></div>
            <div className="pdf-modal__body"><p className="admin-delete-modal__text">Naozaj chcete vymazať parametre {deleteParam.bankaKod} - <strong>{deleteParam.typHypoteky}</strong>? Tento typ prestane byť dostupný v porovnávači.</p></div>
            <div className="pdf-modal__footer"><button type="button" className="action-btn" onClick={() => setDeleteParam(null)}>Zrušiť</button><button type="button" className="action-btn admin-danger-btn" onClick={vymazTyp}>Vymazať</button></div>
          </div>
        </div>
      )}

      {deleteBanka && (
        <div className="pdf-modal-overlay" onClick={() => setDeleteBanka(null)}>
          <div className="pdf-modal admin-delete-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal__header"><h2 className="pdf-modal__title">Vymazať banku z parametrov</h2></div>
            <div className="pdf-modal__body"><p className="admin-delete-modal__text">Naozaj chcete vymazať banku <strong>{deleteBanka.bankaKod}</strong> z parametrov? Vymažú sa všetky jej karty typov hypoték. Sadzby a kampane sa tým nemažú.</p></div>
            <div className="pdf-modal__footer"><button type="button" className="action-btn" onClick={() => setDeleteBanka(null)}>Zrušiť</button><button type="button" className="action-btn admin-danger-btn" onClick={vymazBanku}>Vymazať banku</button></div>
          </div>
        </div>
      )}
    </div>
  );
}
